import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Box } from "@material-ui/core";
import { MinimalTopBar } from "components/MinimalTopBar";
import AchievementBadgeAttachment from "components/AchievementBadgeAttachment";

export default function AchievementBadgeAttachmentView() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="sm">
      <MinimalTopBar onGoBack={handleGoBack} />
      <Box mt={3}>
        <AchievementBadgeAttachment />
      </Box>
    </Container>
  );
}